import { render, staticRenderFns } from "./checkoutV9.vue?vue&type=template&id=2db70371&scoped=true"
import script from "./checkoutV9.vue?vue&type=script&lang=js"
export * from "./checkoutV9.vue?vue&type=script&lang=js"
import style0 from "./checkoutV9.vue?vue&type=style&index=0&id=2db70371&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db70371",
  null
  
)

export default component.exports